var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4869 0.879592L10.8505 3.06141C11.0323 3.15172 11.1852 3.29095 11.2922 3.46343C11.3992 3.63592 11.4559 3.83482 11.456 4.03777V9.23595C11.4559 9.43891 11.3992 9.63781 11.2922 9.81029C11.1852 9.98278 11.0323 10.122 10.8505 10.2123L6.4869 12.3941C6.33534 12.47 6.1682 12.5095 5.99872 12.5095C5.82924 12.5095 5.6621 12.47 5.51054 12.3941L1.1469 10.2123C0.965336 10.1208 0.812948 9.98043 0.706931 9.80695C0.600914 9.63346 0.545487 9.43381 0.546901 9.2305V4.03777C0.547009 3.83482 0.603731 3.63592 0.71069 3.46343C0.817649 3.29095 0.970604 3.15172 1.15236 3.06141L5.51599 0.879592C5.66684 0.804633 5.833 0.765625 6.00145 0.765625C6.16989 0.765625 6.33605 0.804633 6.4869 0.879592V0.879592Z",
    stroke: "#51B15C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.722656 3.45312L6.00266 6.09312L11.2827 3.45312M6.00266 12.5077V6.09312",
    stroke: "#51B15C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkuIcon);
export default __webpack_public_path__ + "static/media/skuIcon.50c3438de7dcbd3947a8ecb3b9d7f142.svg";
export { ForwardRef as ReactComponent };